import { useEffect, useState } from "react";
import { fetchUserFromInviteToken } from "../../../services/b2b-users-apiService";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";

const useGettingUserFromInviteToken = (inviteToken) => {
    const [user, setUser] = useState(null);
    const { locale } = useB2BTranslation('other');

    const getUserFromInviteToken = async () => {
        try {
            let response = await fetchUserFromInviteToken(inviteToken);
            response = {
                ...response,
                locale: locale,
            };
            setUser(response);
        } catch (error) {
            console.error('Error fetching user from invite token:', error);
        }
    };

    useEffect(() => {
        if (inviteToken) {
            getUserFromInviteToken();
        }
    }, [inviteToken]);

    return { user, setUser, isLoading: !user };
}

export default useGettingUserFromInviteToken;